// Foreach on Nodelist polyfill
// Because forEach doesn't work on a Nodelist in Edge
// More info: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10638731/
if (!NodeList.prototype.forEach && Array.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}